export const GEMINI_1 = 'gemini_1';
export const GEMINI_2 = 'gemini_2';
export const SAGITTARIUS = 'sagittaire';
export const CASSIOPEIA = 'cassiopée';
export const ANDROMEDA = 'andromède';
export const ORION = 'orion';
export const AQUARIUS = 'verseau';
export const CAPRICORN = 'capricorne';
export const BOREALIS = 'borealis';